// extracted by mini-css-extract-plugin
export default {"title":"ActionHeader_title__ltlU4","subtitle":"ActionHeader_subtitle__9Fr9N"};